import { $$, doc } from './util.js';

/* TABLES IN ARTICLE BODIES
   --------------------------------------------------------------------------
   A table in CMS prose needs two things CSS cannot give it at once: the full
   width of the text column, and a scroll port of its own (horizontal for a wide
   table, vertical for a long one, with the "more below" shadow). A scroll port
   needs `display: block`, and a block-level <table> wraps its rows in an
   anonymous table that shrinks to its content, so short tables came out
   narrower than long ones.

   So the scroll port moves to a wrapper: each table gets a .table-wrap parent
   and goes back to being an ordinary full-width table (_article.scss). Without
   this script the old block-level table still renders and scrolls; it is only
   narrower. Nested tables stay inside their outer table's wrapper. */

export function initTableWrap() {
	$$('.article-body table').forEach(function (table) {
		var parent = table.parentElement;
		if (!parent || parent.classList.contains('table-wrap') || parent.closest('table')) { return; }
		var wrap = doc.createElement('div');
		wrap.className = 'table-wrap';
		parent.insertBefore(wrap, table);
		wrap.appendChild(table);
	});
}
